import OrbitApiV1 from '.'

class MsisdnAPI {
  static async getMsisdn(limit) {
    return OrbitApiV1.httpGet(`/msisdn?limit=${limit}`)
  }
}

export default MsisdnAPI
